module.exports = __webpack_public_path__ + "img/file-pdf-outline.673d18eb.svg";